
import { Component, ViewChild, OnInit, ElementRef, Renderer2 } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { Response } from '@angular/http';
import { NgForm, FormControl, FormGroup, FormBuilder } from '@angular/forms';

import { NavigationService } from '../../shared-services/navigation.service';
import { SnackService } from '../../shared-services/snack.service';
import { BackendService } from '../../core/backend.service';
import { HttpClient } from '@angular/common/http';
import { ProveedorSimple } from '../modificacion-precio/proovedor-simple.model';
import { Role } from '../../security/role/role.model';
import { SecurityService } from '../../security/security.service';
import { Producto } from '../producto.model';

@Component({
  selector: 'app-producto-add-massive',
  templateUrl: './producto-add-massive.component.html',
  styleUrls: ['./producto-add-massive.component.scss']
})
export class ProductoAddMassiveComponent implements OnInit {
  @ViewChild('UploadFileInput') uploadFileInput: ElementRef;
  fileUploadForm: FormGroup;
  fileInputLabel: string;
  proovedores: ProveedorSimple[] = [];

  proveedorId: number;
  paisSeleccionado: string;
  numberPaisId: number = 0;
  nombrePais: string;
  proveedorSimple: ProveedorSimple;
  user: any;
  rol: Role;

  constructor(
    private activatedRoute: ActivatedRoute,
    private navigationService: NavigationService,
    protected router: Router,
    private http: HttpClient,
    private formBuilder: FormBuilder,
    private snackService: SnackService,
    private backendService: BackendService,
    private authService: SecurityService
) {}

    ngOnInit() {

      this.user = this.authService.user;

      this.getRol();

      this.backendService.get(ProveedorSimple,"/new-productos/proveedores",null).toPromise().then(a =>{
        this.proovedores = a;
      });
    
    this.fileUploadForm = this.formBuilder.group({
      myfile: [''],
      proveedorId: [undefined],
      pass: [undefined]
    });
    this.getIdPais();
    this.getNombrePais();
  }

  onProvSelect(event){
    console.log(event.value);
    this.proveedorId = event.value;
  }

  onPaisSelect(event){
    console.log(event.value);
    this.paisSeleccionado = event.value;
  }

  onFileSelect(event) {
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      this.fileInputLabel = file.name;
      this.fileUploadForm.get('myfile').setValue(file);
    }
  }

  async onFormSubmit() {

        if (!this.fileUploadForm.get('myfile').value) {
            this.snackService.warn('Por favor, seleccione un archivo válido');
            return false;
        }

        const formData = new FormData();
        formData.append('file', this.fileUploadForm.get('myfile').value);

        this.snackService.spinner(true);
        try {
            await this.backendService.createFile('/new-productos/add-massive-productos/'+ this.proveedorId+'/'+this.paisSeleccionado, formData);
            this.snackService.success('Productos agregados satisfactoriamente');
            if (this.proveedorSimple != null){
              this.router.navigate(['/productos/por-proveedor']); 
            }
            if (this.proveedorSimple == null){
              this.router.navigate(['/productos']);
            }
        } catch (ex) {
            if (ex[0]) {
                this.snackService.error(ex[0].details);
            } else if (ex.errors) {
                this.snackService.error(ex.errors[0].defaultMessage);
            } else {
                this.snackService.error(ex.message);
            }
        } finally {
            this.snackService.spinner(false);
        }
    }

    back() {
      this.router.navigate(['/productos']);
    }

    compareFn(c1: any, c2: any): boolean {
      return c1 && c2 ? c1.id === c2.id : c1 === c2;
    }

    async getUsuarioInternoProveedor(){
      await this.backendService.get(ProveedorSimple, Producto.newPath+ "proveedor_user/"+this.user.id).toPromise().then(a => {
        this.proveedorSimple = a as ProveedorSimple;
        this.proveedorId = this.proveedorSimple.id;
      })
    }
  
    async getRol(){
      await this.backendService.get(Role,"/new-roles/user/"+this.user.id).toPromise().then(a =>{
        this.rol = a as Role;
      });
      if (this.rol.name == 'SELLER CENTER'){
        this.getUsuarioInternoProveedor();
      }
    }

    async getIdPais(){
      await this.backendService.getPrecio("/usuarios_internos/get_usuario_pais").then(a =>{
        this.numberPaisId = a as number;
        } );    
        this.getNombrePais();
    }
  
    getNombrePais() {
      if (this.numberPaisId == 55) 
        this.nombrePais = 'ARGENTINA';
      else if (this.numberPaisId == 63)
        this.nombrePais = 'CHILE';
      }

}




// WEBPACK FOOTER //
// ./src/app/productos/producto-add-massive/producto-add-massive.component.ts